import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: () => import('@/views/homePage'),
      meta: { title: "首页" },
      children: [
        {
          path: '',
          name: '首页',
          component: () => import('@/views/index'),
          // meta:{ title: "首页" },
        },
        {
          path: '/about',
          name: '行业资讯',
          component: () => import('@/views/about'),
          meta: {
            title: "行业资讯",
          },
          children: [
            {
              path: '',
              component: () => import('@/views/about/newsList'),
            },
            {
              path: 'detail',
              component: () => import('@/views/about/newsDetail'),
              meta: {
                title: "行业咨讯详情",
              }
            },
          ],
        },
        {
          path: '/user',
          name: '用户',
          component: () => import('@/views/user/user'),
          meta: {
            title: "个人中心",
          },
          children: [
            {
              path: '',
              component: () => import('@/views/user/Uindex')
            },
            {
              path: 'collect',
              component: () => import('@/views/user/myCollect')
            },
            {
              path: 'oder',
              component: () => import('@/views/user/myOrder')
            },
            {
              path: 'apply',
              component: () => import('@/views/user/apply')
            },
            {
              path: 'news',
              component: () => import('@/views/user/news')
            },
            {
              path: 'touch',
              component: () => import('@/views/user/touch')
            },
            {
              path: 'detail',
              component: () => import('@/views/user/detail'),
            },
            {
              path: 'feedback',
              component: () => import('@/views/user/feedback'),
            },
          ]
        },
        {
          path: '/serve',
          name: '专业服务',
          component: () => import('@/views/serve/serve'),
          meta: {
            title: "专业服务",
          },
          children: [
            {
              path: '',
              name: '第一页',
              component: () => import('@/views/serve/index')
            },
            {
              path: 'detail',
              name: '服务详情',
              component: () => import('@/views/serve/serveDetail'),
              meta: {
                title: "服务详情",
              }
            }
          ]
        },
        {
          path: '/facility',
          name: '仪表商城',
          component: () => import('@/views/facility/facility'),
          meta: {
            title: "仪表商城",
          },
          children: [
            {
              path: '',
              name: '第一页',
              component: () => import('@/views/facility/index')
            },
            {
              path: 'detail',
              name: '商品详情',
              component: () => import('@/views/facility/facilityDetail'),
              meta: {
                title: "商品详情",
              },
            }
          ]
        },
        {
          path: '/supplier',
          name: '品牌供应商',
          component: () => import('@/views/supplier/index'),
          meta: {
            title: "品牌商",
          },
          children: [
            {
              path: '',
              name: '品牌商',
              component: () => import('@/views/supplier/supplier'),
            },
            {
              path: 'detail',
              name: '品牌商',
              component: () => import('@/views/supplier/supdetail'),
              meta: {
                title: "供应商信息",
              },
              children: [
                {
                  path: '',
                  name: '品牌供应商商品内容',
                  component: () => import('@/views/supplier/supshop'),
                },
                {
                  path: 'shopdetail',
                  name: '仪器商品',
                  component: () => import('@/views/supplier/supshopdetail'),
                  meta: {
                    title: "仪器商品",
                  },
                },
                {
                  path: 'shopdetail2',
                  name: '专业服务',
                  component: () => import('@/views/supplier/supshopdetail2'),
                  meta: {
                    title: "专业服务",
                  },
                },
              ]
            }
          ]
        },
        {
          // 搜索结果页
          path: '/news',
          name: '行业资讯',
          component: () => import('@/views/botpage/news'),
          meta: { title: "行业资讯" },
        },
        {
          path: '/serves',
          name: '专业服务',
          component: () => import('@/views/botpage/serve'),
          meta: { title: "专业服务" },
        },
        {
          path: '/seafacility',
          name: '仪器仪表',
          component: () => import('@/views/botpage/facility'),
          meta: { title: "仪器仪表" },
        },
        {
          path: '/supplierseach',
          name: '仪器仪表',
          component: () => import('@/views/botpage/supplierseach'),
          meta: { title: "仪器仪表" },
        },
        {
          path: '/touch1',
          component: () => import('@/views/user/touch1'),
          meta: { title: "用户协议" },
        },
        {
          path: '/touch2',
          component: () => import('@/views/user/touch2'),
          meta: { title: "隐私协议" },
        },
      ]
    },
    {
      path: '/login',
      name: '登录',
      component: () => import('@/views/login/login')
    },
    {
      path: '/register',
      name: '注册',
      component: () => import('@/views/login/register')
    },
    {
      path: '/reset',
      name: '重置密码',
      component: () => import('@/views/login/reset')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js